module.exports = __webpack_public_path__ + "static/media/gradient-mode-none.fa53efc6.svg";